import { html } from "lit-html"

const Location = (location) =>
  location
    ? html`
        <a
          href="https://www.google.com/maps/dir/?api=1&destination=${window.encodeURIComponent(
            location.display
          )}"
        >
          <i class="fas fa-map-marker-alt"></i>
          &nbsp;
          <span>${location.display}</span> (Directions)
        </a>
      `
    : html` <span>Location unavailable</span> `

export default Location
